import * as React from "react";

function ExternalLink(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 13 13" fill="none" {...props}>
      <path
        d="M5.9 1a.5.5 0 10-.002-1C4.69.002 3.723.017 2.952.142c-.785.127-1.42.376-1.927.883-.548.547-.793 1.243-.91 2.116C0 3.99 0 5.079 0 6.46v.075c0 1.382 0 2.47.114 3.32.118.872.363 1.569.911 2.116.548.548 1.244.794 2.116.911.85.114 1.938.114 3.32.114h.076c1.382 0 2.47 0 3.32-.114.872-.117 1.568-.363 2.116-.91.507-.508.756-1.143.883-1.928.124-.77.14-1.738.142-2.946a.5.5 0 00-1-.002c-.003 1.225-.02 2.11-.13 2.789-.107.663-.295 1.072-.602 1.38-.331.33-.781.524-1.542.626-.776.104-1.797.105-3.225.105-1.428 0-2.449 0-3.225-.105-.761-.102-1.211-.296-1.542-.627-.33-.33-.524-.78-.627-1.542C1.001 8.947 1 7.926 1 6.498c0-1.428.001-2.448.105-3.224.103-.761.296-1.211.627-1.542.307-.307.716-.496 1.38-.603C3.79 1.019 4.675 1.002 5.9 1z"
        fill="#415466"
      />
      <path
        d="M12.506.49a1.013 1.013 0 00-.402-.229 2.825 2.825 0 00-.414-.097 8.909 8.909 0 00-.968-.092 25.915 25.915 0 00-1.593-.02.5.5 0 10.014 1c.234-.004.892-.013 1.529.018.178.01.35.021.508.037L8.1 4.179a.5.5 0 10.706.708l3.083-3.074c.015.16.027.333.036.513.032.637.023 1.296.02 1.53a.5.5 0 001 .014 25.96 25.96 0 00-.021-1.594 8.932 8.932 0 00-.093-.97 2.833 2.833 0 00-.096-.414 1.013 1.013 0 00-.229-.402z"
        fill="#415466"
      />
    </svg>
  );
}

const MemoExternalLink = React.memo(ExternalLink);
export default MemoExternalLink;
